import { useState } from "react";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import APP_ROUTES from "src/routes/routes";
import { getTestPackages } from "src/services/test-packages";
import { handleScrollTo } from "src/utils/common";

const useGetTestPackageList = (
  {
    page = 1,
    limit = 9999999,
    q,
    yamcs_package_id,
    isSelectOptions,
    exceptionId,
    key = "getTestPackages",
    hasTags = false,
    id,
    enabled = true,
    refetchOnWindowFocus = true,
  } = {},
  onSettledCallback
) => {
  const [allowScrollToId, setAllowScrollToId] = useState(true);
  const navigate = usePatchedNavigate();

  const queryFn = () => {
    const params = { page, limit, ...(q && { q }), ...(yamcs_package_id && { yamcs_package_id }) };
    return getTestPackages(params);
  };

  const { data, isError, error, refetch, isFetching, isLoading } = useQuery({
    queryKey: [key, q, yamcs_package_id, page],
    queryFn,
    cacheTime: 0,
    select: (data) => {
      let finalData = data;
      if (exceptionId && data?.items) {
        finalData.items = data?.items?.filter((item) => item.id !== exceptionId) || [];
      }
      if (hasTags && finalData?.items) {
        finalData.items = finalData.items?.filter((item) => item.number_of_tags > 0) || [];
      }
      if (isSelectOptions) {
        return (
          finalData?.items?.map((item) => ({
            label: item.combination_id,
            value: item.id,
            createdAt: item.created_at,
          })) || []
        );
      }
      return finalData;
    },
    onSuccess: async () => {
      if (id && allowScrollToId) {
        handleScrollTo(0, 90, `row${id}`);
        setAllowScrollToId(false);
      }
    },
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    onSettled: () => {
      if (onSettledCallback) {
        onSettledCallback();
      }
    },
    enabled,
    refetchOnWindowFocus,
  });

  return {
    testPackageList: data,
    testPackageListRefetch: refetch,
    isFetchingTestPackageList: isFetching,
    isLoadingTestPackageList: isLoading,
    isErrorTestPackageList: isError,
    errorTestPackageList: error,
  };
};

export default useGetTestPackageList;
